import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

interface QueueStatus {
	counts: {
		waiting: number;
		active: number;
		delayed: number;
		failed: number;
		completed: number;
		paused: number;
	};
	isPaused: boolean;
}

export function useSyncQueueStatus() {
	return useQuery<QueueStatus>({
		queryKey: ["sync-queue"],
		queryFn: async () => api.get("/api/sync/queue"),
		refetchInterval: (query) => (query.state.error ? false : 5000),
	});
}

export function usePauseSyncQueue() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: () => api.post("/api/sync/queue/pause", {}),
		onSuccess: () => qc.invalidateQueries({ queryKey: ["sync-queue"] }),
	});
}

export function useResumeSyncQueue() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: () => api.post("/api/sync/queue/resume", {}),
		onSuccess: () => qc.invalidateQueries({ queryKey: ["sync-queue"] }),
	});
}

interface ClearQueueResult {
	success: boolean;
	removedWaiting: number;
	removedDelayed: number;
	removedFailed: number;
	removedCompleted: number;
}

export function useClearSyncQueue() {
	const qc = useQueryClient();
	return useMutation<
		ClearQueueResult,
		Error,
		{ removeFailed?: boolean; removeCompleted?: boolean }
	>({
		mutationFn: (body) => api.post("/api/sync/queue/clear", body),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ["sync-queue"] });
			qc.invalidateQueries({ queryKey: ["sync-logs"] });
		},
	});
}
